import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "cinema__header-single-row"
};
const _hoisted_2 = {
  class: "cinema__header-tabs"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "spot"
}, null, -1);
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "spot"
}, null, -1);
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "spot"
}, null, -1);
const _hoisted_7 = [_hoisted_4, _hoisted_5, _hoisted_6];
const _hoisted_8 = {
  class: "cinema__header-double-row-1 bg-white"
};
const _hoisted_9 = {
  class: "cinema__header-double-row-2"
};
const _hoisted_10 = {
  class: "cinema__header-tabs"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", {
  class: "spot"
}, null, -1);
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  class: "spot"
}, null, -1);
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  class: "spot"
}, null, -1);
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "首页可添加文件夹了，快试试吧~", -1);
const _hoisted_16 = [_hoisted_15];
import { onMounted, ref, watch } from 'vue';
import { openPopMenu, openPopCinemaSearch, openCinemaSourceSetting } from '@remote/utils/dialog';
import { IconHome, IconXunlei, IconSearch } from '@xunlei/thunder-icon-vue';
import { useGoHome } from '@remote/composable/home';
import { useDeviceStore } from '@remote/store/device';
import { store } from '@remote/store';
import { stat } from '@remote/utils/stat';
import router from '@remote/router';
import { useCinemaSearchStat } from '@shared/composable/cinema';
import { useEnvStore } from '@remote/store/env';
import { isAndroidNative, isHarmonyNative } from '@xunlei/universal-native-api';
export default /*#__PURE__*/_defineComponent({
  __name: 'CinemaHeader',
  props: {
    slides: {
      type: Array,
      required: true
    },
    currentSlideIndex: {
      type: Number,
      default: 0
    },
    headerVersionWithoutSearch: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:currentSlideIndex'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const deviceStore = useDeviceStore();
    const {
      statSearchEntryClick
    } = useCinemaSearchStat(stat);
    const {
      goHome,
      isNative
    } = useGoHome();
    const envStore = useEnvStore();
    const isIndexFolderBubbleShow = ref(false);
    const selectTab = index => {
      var _deviceStore$currentN;
      stat({
        action: 'cinema_tab_click',
        data: {
          click_id: props.slides[index].stat
        }
      });
      (_deviceStore$currentN = deviceStore.currentNFOInstance) === null || _deviceStore$currentN === void 0 ? void 0 : _deviceStore$currentN.selectTab(props.slides[index].id);
      if (index === 0) {
        var _deviceStore$currentD, _deviceStore$currentN2;
        if ((_deviceStore$currentD = deviceStore.currentDeviceRef) !== null && _deviceStore$currentD !== void 0 && _deviceStore$currentD.indexShortCut.isCinemaIndexFolderEnabled) {
          var _deviceStore$currentD2, _deviceStore$currentD3;
          (_deviceStore$currentD2 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD2 === void 0 ? void 0 : _deviceStore$currentD2.indexShortCut.refreshFolderList();
          (_deviceStore$currentD3 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD3 === void 0 ? void 0 : _deviceStore$currentD3.indexShortCut.getIsCinemaIndexShow();
        }
        (_deviceStore$currentN2 = deviceStore.currentNFOInstance) === null || _deviceStore$currentN2 === void 0 ? void 0 : _deviceStore$currentN2.syncHasInitCinema();
      }
      emit('update:currentSlideIndex', index);
    };
    const createMenu = async () => {
      var _deviceStore$currentD4, _deviceStore$currentD5, _deviceStore$currentN3, _deviceStore$currentD6;
      const menu = ['刷新', '来源管理'];
      if ((_deviceStore$currentD4 = deviceStore.currentDeviceRef) !== null && _deviceStore$currentD4 !== void 0 && _deviceStore$currentD4.util.hasLabel('withVFS')) {
        menu.push('文件源');
      } else if ((_deviceStore$currentD5 = deviceStore.currentDeviceRef) !== null && _deviceStore$currentD5 !== void 0 && _deviceStore$currentD5.util.hasLabel('withSyncDriveFile')) {
        menu.push('本地文件');
      }
      if ((_deviceStore$currentN3 = deviceStore.currentNFOInstance) !== null && _deviceStore$currentN3 !== void 0 && _deviceStore$currentN3.hasInitCinema && (_deviceStore$currentD6 = deviceStore.currentDeviceRef) !== null && _deviceStore$currentD6 !== void 0 && _deviceStore$currentD6.indexShortCut.isCinemaIndexFolderEnabled) {
        menu.push('添加首页文件夹');
        const folderList = deviceStore.currentDeviceRef.indexShortCut.folderList;
        if (folderList && folderList.length > 0) {
          var _deviceStore$currentD7;
          menu.push((_deviceStore$currentD7 = deviceStore.currentDeviceRef) !== null && _deviceStore$currentD7 !== void 0 && _deviceStore$currentD7.indexShortCut.isCinemaIndexFolderShow ? '隐藏首页文件夹' : '显示首页文件夹');
        }
      }
      return menu;
    };
    const hideBubble = () => {
      if (isIndexFolderBubbleShow.value) {
        isIndexFolderBubbleShow.value = false;
      }
    };
    const unwatch = watch(() => {
      var _deviceStore$currentN4;
      return (_deviceStore$currentN4 = deviceStore.currentNFOInstance) === null || _deviceStore$currentN4 === void 0 ? void 0 : _deviceStore$currentN4.hasInitCinema;
    }, (val, oldVal) => {
      if (oldVal === false && val === true) {
        hideBubble();
        unwatch();
      }
    }, {
      immediate: true
    });
    const openMenu = async () => {
      var _deviceStore$currentN5, _deviceStore$currentD8, _deviceStore$currentD9, _deviceStore$currentD10, _deviceStore$currentD11, _deviceStore$currentD12;
      hideBubble();
      const menu = await createMenu();
      stat({
        action: 'more_option_show'
      });
      const result = await openPopMenu({
        options: menu
      });
      switch (result) {
        case '刷新':
          (_deviceStore$currentN5 = deviceStore.currentNFOInstance) === null || _deviceStore$currentN5 === void 0 ? void 0 : _deviceStore$currentN5.createScrapeTask('manual_btn_click');
          (_deviceStore$currentD8 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD8 === void 0 ? void 0 : _deviceStore$currentD8.indexShortCut.refreshFolderList();
          (_deviceStore$currentD9 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD9 === void 0 ? void 0 : _deviceStore$currentD9.indexShortCut.getIsCinemaIndexShow();
          store.commit('toast', '正在刷新，刷新完毕会自动更新列表');
          stat({
            action: 'cinema_tab_click',
            data: {
              click_id: 'refresh'
            }
          });
          break;
        case '来源管理':
          openCinemaSourceSetting({
            from: 'source_setting'
          });
          stat({
            action: 'cinema_tab_click',
            data: {
              click_id: 'source_setting'
            }
          });
          break;
        case '本地文件':
          router.push({
            path: '/local-files/',
            query: router.currentRoute.value.query
          });
          stat({
            action: 'cinema_tab_click',
            data: {
              click_id: 'local_file'
            }
          });
          break;
        case '文件源':
          router.push({
            path: '/sources/',
            query: router.currentRoute.value.query
          });
          stat({
            action: 'cinema_tab_click',
            data: {
              click_id: 'file_source'
            }
          });
          break;
        case '添加首页文件夹':
          stat({
            action: 'cinema_tab_click',
            data: {
              click_id: 'main_page_file_add'
            }
          });
          (_deviceStore$currentD10 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD10 === void 0 ? void 0 : _deviceStore$currentD10.indexShortCut.add();
          break;
        case '显示首页文件夹':
          stat({
            action: 'cinema_tab_click',
            data: {
              click_id: 'main_page_file_show'
            }
          });
          (_deviceStore$currentD11 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD11 === void 0 ? void 0 : _deviceStore$currentD11.indexShortCut.toggleCinemaIndexShow();
          break;
        case '隐藏首页文件夹':
          stat({
            action: 'cinema_tab_click',
            data: {
              click_id: 'main_page_file_hide'
            }
          });
          (_deviceStore$currentD12 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD12 === void 0 ? void 0 : _deviceStore$currentD12.indexShortCut.toggleCinemaIndexShow();
          break;
      }
    };
    const onSearchClick = () => {
      openPopCinemaSearch({});
      statSearchEntryClick();
    };
    onMounted(async () => {
      var _deviceStore$currentD13;
      if ((_deviceStore$currentD13 = deviceStore.currentDeviceRef) !== null && _deviceStore$currentD13 !== void 0 && _deviceStore$currentD13.indexShortCut.isCinemaIndexFolderEnabled) {
        var _deviceStore$currentD14, _deviceStore$currentD15, _deviceStore$currentD16, _deviceStore$currentD17;
        (_deviceStore$currentD14 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD14 === void 0 ? void 0 : _deviceStore$currentD14.indexShortCut.initMenu();
        const uid = (_deviceStore$currentD15 = (_deviceStore$currentD16 = deviceStore.currentDeviceRef.deviceInfoRef.user) === null || _deviceStore$currentD16 === void 0 ? void 0 : _deviceStore$currentD16.id) !== null && _deviceStore$currentD15 !== void 0 ? _deviceStore$currentD15 : '';
        const canShow = await ((_deviceStore$currentD17 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD17 === void 0 ? void 0 : _deviceStore$currentD17.dialogManager.canDialogShow({
          uid,
          dialogID: 'INDEX_FOLDER_BUBBLE'
        }));
        if (canShow) {
          var _deviceStore$currentD18;
          isIndexFolderBubbleShow.value = true;
          stat({
            action: 'local_main_page_file_pop_show'
          });
          (_deviceStore$currentD18 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD18 === void 0 ? void 0 : _deviceStore$currentD18.dialogManager.dialogShow({
            uid,
            dialogID: 'INDEX_FOLDER_BUBBLE'
          });
        }
      }
    });
    return (_ctx, _cache) => {
      var _unref$currentNFOInst, _unref$currentNFOInst2;
      return _openBlock(), _createElementBlock("header", {
        class: _normalizeClass({
          'cinema__header': true,
          'android-padding': _unref(isAndroidNative),
          'ios-padding': _unref(envStore).isUseIOSHeader,
          'harmony-padding': _unref(isHarmonyNative)
        })
      }, [__props.headerVersionWithoutSearch ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("button", {
        class: "cinema__header-home",
        onClick: _cache[0] || (_cache[0] =
        //@ts-ignore
        (...args) => _unref(goHome) && _unref(goHome)(...args))
      }, [_unref(isNative) ? (_openBlock(), _createBlock(_unref(IconHome), {
        key: 0,
        width: "36",
        height: "36"
      })) : (_openBlock(), _createBlock(_unref(IconXunlei), {
        key: 1,
        width: "24",
        height: "24"
      }))]), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.slides, (slide, index) => {
        return _openBlock(), _createElementBlock("span", {
          class: _normalizeClass({
            'tab': true,
            'is-active': index === __props.currentSlideIndex
          }),
          key: slide.title,
          onClick: $event => selectTab(index)
        }, _toDisplayString(slide.title), 11, _hoisted_3);
      }), 128))]), _createElementVNode("div", {
        class: _normalizeClass({
          'cinema__header-more': true,
          'is-animate': (_unref$currentNFOInst = _unref(deviceStore).currentNFOInstance) === null || _unref$currentNFOInst === void 0 ? void 0 : _unref$currentNFOInst.isScraping
        }),
        onClick: openMenu
      }, _hoisted_7, 2)])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("button", {
        class: "cinema__header-home",
        onClick: _cache[1] || (_cache[1] =
        //@ts-ignore
        (...args) => _unref(goHome) && _unref(goHome)(...args))
      }, [_unref(isNative) ? (_openBlock(), _createBlock(_unref(IconHome), {
        key: 0,
        width: "36",
        height: "36"
      })) : (_openBlock(), _createBlock(_unref(IconXunlei), {
        key: 1,
        width: "24",
        height: "24"
      }))]), _createElementVNode("div", {
        class: "cinema__header-search",
        onClick: onSearchClick
      }, [_createVNode(_unref(IconSearch), {
        width: "16px",
        height: "16px"
      }), _createTextVNode(" 输入影片名称 ")])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.slides, (slide, index) => {
        return _openBlock(), _createElementBlock("span", {
          class: _normalizeClass({
            'tab': true,
            'is-active': index === __props.currentSlideIndex
          }),
          key: slide.title,
          onClick: $event => selectTab(index)
        }, _toDisplayString(slide.title), 11, _hoisted_11);
      }), 128))]), _createElementVNode("div", {
        class: _normalizeClass({
          'cinema__header-more': true,
          'is-animate': (_unref$currentNFOInst2 = _unref(deviceStore).currentNFOInstance) === null || _unref$currentNFOInst2 === void 0 ? void 0 : _unref$currentNFOInst2.isScraping
        }),
        onClick: openMenu
      }, [_hoisted_12, _hoisted_13, _hoisted_14, _withDirectives(_createElementVNode("div", {
        class: "index-folder-bubble",
        onClick: hideBubble
      }, _hoisted_16, 512), [[_vShow, isIndexFolderBubbleShow.value]])], 2)])], 64))], 2);
    };
  }
});